<template>
  <v-app :class="{
    'app-loading' : $store.state.loadingCount > 0,
    'sm-up' : $vuetify.breakpoint.smAndUp,
    'sm-down' : $vuetify.breakpoint.smAndDown,
    'md-up' : $vuetify.breakpoint.mdAndUp,
    'md-down' : $vuetify.breakpoint.mdAndDown,
    'lg-up' : $vuetify.breakpoint.lgAndUp,
    'lg-down' : $vuetify.breakpoint.lgAndDown,
    'xl-only' : $vuetify.breakpoint.xlOnly,
    }">
    <v-main>
      <router-view></router-view>
    </v-main>
    <img
      id="virtual-cursor"
      class="virtual-cursor"
      :src="$asset('image/spinner.png')"
    />
  </v-app>
</template>

<script>
/**
 * Component App.vue
 *
 * Main application component
 *
 * @module App
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/App.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

import errorPopup from '../helper/error_reporting';

export default {
  name: 'App',
  created() {
    this.$store.subscribe((mutation) => {
      errorPopup(this, mutation)
    })
  }
};
</script>
